import { render, staticRenderFns } from "./SoftwareGeneralInfoForm.vue?vue&type=template&id=d145f37a&"
import script from "./SoftwareGeneralInfoForm.vue?vue&type=script&lang=ts&"
export * from "./SoftwareGeneralInfoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports